import { render } from "./Familias.vue?vue&type=template&id=f929b6dc&ts=true"
import script from "./Familias.vue?vue&type=script&lang=ts"
export * from "./Familias.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__